    

    /*
    
    rewards removed:
    <TextAreaButton pic="rewards" label="Rewards" :fieldAddress="[compIndex, 'customRewardWelcome']" validation="max:250|required"  @handleErrors="handleErrors" placeholder="Tell respondents how they'll be rewarded for leaving feedback." description="Reward respondents at the end of their survey with your own special code or secret keyword. You must specify the code and reward criteria on the last step of your survey" descriptionTip="Here's a tip"/>
    
    */

    import Vue, { PropType } from 'vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import StepContainer from './common/StepContainer.vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import WelcomeVideo from './common/WelcomeVideo.vue'
    import Checkbox from './common/Checkbox.vue'
    import WelcomeRepresentative from './common/WelcomeRepresentative.vue'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'

    export default Vue.extend({
        //--------        

        mixins: [RepeatingStepLogic, HelperMethods],

        //--------

        created (): void {

        },        

        props: {
            compIndex: Number
        },

        //--------
        components: {
            surveystep: StepContainer,
            TextInputButton,
            TextAreaButton,
            WelcomeVideo,
            WelcomeRepresentative,
            Checkbox,
            ContentDisplayClosed
        }

    })
